<div class="wholesaler-definitions-admin p-3">
  <h2>{{ 'INVOICE_IMPORTS.ADMIN.TITLE' | translate }}</h2>
  <div class="alert alert-danger" *ngIf="loadError">{{ loadError }}</div>

  <div class="row g-3" *ngIf="!loadError">
    <div class="col-md-4">
      <div class="list-group">
        <button
          type="button"
          class="list-group-item list-group-item-action"
          *ngFor="let def of definitions"
          [class.active]="selected?.supplierKey === def.supplierKey"
          (click)="select(def)">
          {{ def.displayName }}
          <span class="badge bg-secondary float-end">v{{ def.version }}</span>
        </button>
      </div>
    </div>
    <div class="col-md-8" *ngIf="selected">
      <nb-card>
        <nb-card-header>{{ selected.supplierKey }} · v{{ selected.version }}</nb-card-header>
        <nb-card-body>
          <div class="mb-2">
            <label class="form-label">{{ 'INVOICE_IMPORTS.ADMIN.DISPLAY_NAME' | translate }}</label>
            <input class="form-control" [(ngModel)]="displayName" />
          </div>
          <div class="mb-2">
            <label class="form-label">{{ 'INVOICE_IMPORTS.ADMIN.DESCRIPTION' | translate }}</label>
            <textarea class="form-control" rows="2" [(ngModel)]="description"></textarea>
          </div>
          <div class="form-check mb-3">
            <input class="form-check-input" type="checkbox" [(ngModel)]="isActive" id="defActive" />
            <label class="form-check-label" for="defActive">{{ 'INVOICE_IMPORTS.ADMIN.IS_ACTIVE' | translate }}</label>
          </div>
          <div class="mb-2">
            <label class="form-label">{{ 'INVOICE_IMPORTS.ADMIN.DOMAINS' | translate }}</label>
            <textarea class="form-control font-monospace small" rows="3" [(ngModel)]="approvedDomains"></textarea>
          </div>
          <div class="mb-2">
            <label class="form-label">{{ 'INVOICE_IMPORTS.ADMIN.ADDRESSES' | translate }}</label>
            <textarea class="form-control font-monospace small" rows="3" [(ngModel)]="approvedAddresses"></textarea>
          </div>
          <div class="mb-2">
            <label class="form-label">behaviorDefaults (JSON)</label>
            <textarea class="form-control font-monospace small" rows="4" [(ngModel)]="behaviorDefaultsJson"></textarea>
          </div>
          <div class="mb-2">
            <label class="form-label">routingConfig (JSON)</label>
            <textarea class="form-control font-monospace small" rows="6" [(ngModel)]="routingConfigJson"></textarea>
          </div>
          <div class="mb-2">
            <label class="form-label">storeSetupSchema (JSON)</label>
            <textarea class="form-control font-monospace small" rows="8" [(ngModel)]="storeSetupSchemaJson"></textarea>
          </div>
          <div class="text-danger small" *ngIf="jsonError">{{ jsonError }}</div>
          <button type="button" class="btn btn-primary" (click)="save()">{{ 'INVOICE_IMPORTS.COMMON.SAVE' | translate }}</button>
        </nb-card-body>
      </nb-card>
    </div>
  </div>
</div>
